import { useEffect, useMemo } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";

import { useAppDispatch, useAppSelector } from "@chef/state-management/hooks";
import { openModal, selectTrackingIsConfigured } from "@chef/state-management";
import { BRAND_PATHS } from "@chef/constants";

const StandaloneProductModal = dynamic(
  () =>
    import("./StandaloneProductModal").then(
      (mod) => mod.StandaloneProductModal,
    ),
  {
    ssr: false,
  },
);

const RecipeModal = dynamic(
  () => import("./RecipeModal").then((mod) => mod.RecipeModal),
  {
    ssr: false,
  },
);

const WeekPortionsModal = dynamic(
  () => import("./WeekPortionsModal").then((mod) => mod.WeekPortionsModal),
  {
    ssr: false,
  },
);

const ConfirmRevertModal = dynamic(
  () => import("./ConfirmRevertModal").then((mod) => mod.ConfirmRevertModal),
  {
    ssr: false,
  },
);
const SubscribedStandaloneModal = dynamic(
  () =>
    import("./SubscribedStandaloneModal").then(
      (mod) => mod.SubscribedStandaloneModal,
    ),
  {
    ssr: false,
  },
);

const WeekSchedulerEditorModal = dynamic(
  () =>
    import("./WeekSchedulerEditor").then((mod) => mod.WeekSchedulerEditorModal),
  {
    ssr: false,
  },
);

const OverrideFeatureFlagsModal = dynamic(
  () =>
    import("./OverrideFeatureFlagsModal").then(
      (mod) => mod.OverrideFeatureFlagsModal,
    ),
  {
    ssr: false,
  },
);

const ResumeOngoingDeviationModal = dynamic(
  () =>
    import("./ResumeOngoingDeviationModal").then(
      (mod) => mod.ResumeOngoingDeviationModal,
    ),
  {
    ssr: false,
  },
);

const PersonalisedRecipesModal = dynamic(
  () =>
    import("./PersonalisedRecipes").then((mod) => mod.PersonalisedRecipesModal),
  {
    ssr: false,
  },
);

const DeviationCartModal = dynamic(
  () => import("./Cart").then((mod) => mod.DeviationCartModal),
  {
    ssr: false,
  },
);

const SubscriptionCartModal = dynamic(
  () => import("./Cart").then((mod) => mod.SubscriptionCartModal),
  {
    ssr: false,
  },
);

const CampaignCartModal = dynamic(
  () => import("./Cart").then((mod) => mod.CampaignCartModal),
  {
    ssr: false,
  },
);

const FilterNavigationModal = dynamic(
  () =>
    import("./FilterNavigationModal").then((mod) => mod.FilterNavigationModal),
  {
    ssr: false,
  },
);

const ConsentModal = dynamic(
  () => import("./ConsentModal").then((mod) => mod.ConsentModal),
  {
    ssr: false,
  },
);

const AccountReactivationModal = dynamic(
  () =>
    import("./AccountReactivationModal").then(
      (mod) => mod.AccountReactivationModal,
    ),
  {
    ssr: false,
  },
);

const CancelSubscriptionModal = dynamic(
  () =>
    import("./CancelSubscriptionModal").then(
      (mod) => mod.CancelSubscriptionModal,
    ),
  {
    ssr: false,
  },
);

const RecipeActionModal = dynamic(
  () => import("./RecipeActionModal").then((mod) => mod.RecipeActionModal),
  {
    ssr: false,
  },
);

const PreselectedRecipesModal = dynamic(
  () =>
    import("./PreselectedRecipesModal").then(
      (mod) => mod.PreselectedRecipesModal,
    ),
  {
    ssr: false,
  },
);

const RenewVippsAgreementModal = dynamic(
  () =>
    import("./RenewVippsAgreementModal").then(
      (mod) => mod.RenewVippsAgreementModal,
    ),
  {
    ssr: false,
  },
);

const ShopItemModal = dynamic(
  () => import("./ShopItemModal").then((mod) => mod.ShopItemModal),
  {
    ssr: false,
  },
);

const AddressChangedAfterCutoffModal = dynamic(
  () =>
    import("./AddressChangedAfterCutoffModal").then(
      (mod) => mod.AddressChangedAfterCutoffModal,
    ),
  {
    ssr: false,
  },
);

const CustomerExistsModal = dynamic(
  () => import("./CustomerExistsModal").then((mod) => mod.CustomerExistsModal),
  {
    ssr: false,
  },
);

const FirstDeliveryInformationModal = dynamic(
  () =>
    import("./FirstDeliveryInformationModal").then(
      (mod) => mod.FirstDeliveryInformationModal,
    ),
  {
    ssr: false,
  },
);

const LeaveWithoutSavingModal = dynamic(
  () =>
    import("./LeaveWithoutSavingModal").then(
      (mod) => mod.LeaveWithoutSavingModal,
    ),
  {
    ssr: false,
  },
);

const ConsentsWarningModal = dynamic(
  () =>
    import("./ConsentsWarningModal").then((mod) => mod.ConsentsWarningModal),
  {
    ssr: false,
  },
);

const DeliveryTimeAdjustedModal = dynamic(
  () =>
    import("./DeliveryTimeAdjustedModal").then(
      (mod) => mod.DeliveryTimeAdjustedModal,
    ),
  {
    ssr: false,
  },
);

const CampaignOrderPauseModal = dynamic(
  () =>
    import("./CampaignOrderPauseModal").then(
      (mod) => mod.CampaignOrderPauseModal,
    ),
  {
    ssr: false,
  },
);

const RemoveAddressModal = dynamic(
  () => import("./RemoveAddressModal").then((mod) => mod.RemoveAddressModal),
  {
    ssr: false,
  },
);

const SubscriptionCancelModal = dynamic(
  () =>
    import("./SubscriptionCancelModal").then(
      (mod) => mod.SubscriptionCancelModal,
    ),
  {
    ssr: false,
  },
);

const ChangeFirstDeliveryDateModal = dynamic(
  () =>
    import("./ChangeFirstDeliveryDateModal").then(
      (mod) => mod.ChangeFirstDeliveryDateModal,
    ),
  {
    ssr: false,
  },
);

const BlockUserInteractionModal = dynamic(
  () =>
    import("./BlockUserInteractionModal").then(
      (mod) => mod.BlockUserInteractionModal,
    ),
  {
    ssr: false,
  },
);

const CheckoutErrorsModal = dynamic(
  () => import("./CheckoutErrorsModal").then((mod) => mod.CheckoutErrorsModal),
  {
    ssr: false,
  },
);

const PreselectorLoaderModal = dynamic(
  () =>
    import("./PreselectorLoaderModal").then(
      (mod) => mod.PreselectorLoaderModal,
    ),
  {
    ssr: false,
  },
);

const RatingAndCommentModal = dynamic(
  () =>
    import("./RatingAndCommentModal").then((mod) => mod.RatingAndCommentModal),
  {
    ssr: false,
  },
);

export const ModalProvider = () => {
  const { open, data } = useAppSelector((state) => state.modal.modal);
  const trackingIsConfigured = useAppSelector(selectTrackingIsConfigured);
  const { asPath } = useRouter();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (trackingIsConfigured) {
      return;
    }

    if (asPath.includes(BRAND_PATHS.INFORMATION_COOKIES_PATH)) {
      return;
    }

    dispatch(openModal({ id: "CONSENT" }));
  }, [dispatch, trackingIsConfigured, asPath]);

  const Modal = useMemo(() => {
    if (!open) {
      return null;
    }

    switch (data.id) {
      case "STANDALONE_PRODUCT":
        return <StandaloneProductModal {...data} />;

      case "RECIPE":
        return <RecipeModal {...data} />;

      case "SUBSCRIBED_STANDALONE":
        return <SubscribedStandaloneModal {...data} />;

      case "WEEK_SCHEDULER_EDITOR":
        return <WeekSchedulerEditorModal {...data} />;

      case "OVERRIDE_FEATURE_FLAGS":
        return <OverrideFeatureFlagsModal />;

      case "RESUME_ONGOING_DEVIATION":
        return <ResumeOngoingDeviationModal {...data} />;

      case "PERSONALISED_RECIPES":
        return <PersonalisedRecipesModal {...data} />;

      case "WEEK_PORTION":
        return <WeekPortionsModal {...data} />;

      case "DEVIATION_CART":
        return <DeviationCartModal {...data} />;

      case "SUBSCRIPTION_CART":
        return <SubscriptionCartModal />;

      case "CAMPAIGN_CART":
        return <CampaignCartModal {...data} />;

      case "FILTER_NAVIGATION":
        return <FilterNavigationModal {...data} />;

      case "CONSENT":
        return <ConsentModal />;

      case "ACCOUNT_REACTIVATION":
        return <AccountReactivationModal {...data} />;

      case "CANCEL_SUBSCRIPTION":
        return <CancelSubscriptionModal {...data} />;

      case "RECIPE_ACTION":
        return <RecipeActionModal />;

      case "PRESELECTED_RECIPES":
        return <PreselectedRecipesModal {...data} />;

      case "RENEW_VIPPS_AGREEMENT":
        return <RenewVippsAgreementModal />;

      case "SHOP_ITEM":
        return <ShopItemModal {...data} />;

      case "ADDRESS_CHANGED_AFTER_CUTOFF":
        return <AddressChangedAfterCutoffModal {...data} />;

      case "CUSTOMER_EXISTS":
        return <CustomerExistsModal {...data} />;

      case "FIRST_DELIVERY_INFORMATION":
        return <FirstDeliveryInformationModal {...data} />;

      case "LEAVE_WITHOUT_SAVING":
        return <LeaveWithoutSavingModal {...data} />;

      case "CONSENTS_WARNING":
        return <ConsentsWarningModal />;

      case "DELIVERY_TIME_ADJUSTED":
        return <DeliveryTimeAdjustedModal {...data} />;

      case "CAMPAIGN_ORDER_PAUSE":
        return <CampaignOrderPauseModal {...data} />;

      case "REMOVE_ADDRESS":
        return <RemoveAddressModal />;

      case "SUBSCRIPTION_CANCEL":
        return <SubscriptionCancelModal />;

      case "CHANGE_FIRST_DELIVERY_DATE":
        return <ChangeFirstDeliveryDateModal {...data} />;

      case "CONFIRM_REVERT":
        return <ConfirmRevertModal {...data} />;

      case "BLOCK_USER_INTERACTION":
        return <BlockUserInteractionModal {...data} />;

      case "CHECKOUT_ERRORS":
        return <CheckoutErrorsModal {...data} />;

      case "PRESELECTOR_LOADER":
        return <PreselectorLoaderModal {...data} />;

      case "RATING_AND_COMMENT":
        return <RatingAndCommentModal {...data} />;

      default:
        return null;
    }
  }, [open, data]);

  return Modal;
};
